import React from "react"
import WinTable from "../../Table/Tables/team_win_total_table"
import winStyles from '../../Table/Tables/team_win_total_table.module.scss'


const WinTotals = () => {

    return(
        <div>
            <WinTable/>
            <div className={winStyles.content_container}>
                <h2 className={winStyles.section_header}>
                    NFL Win Totals Table
                </h2>
                <p className={winStyles.content_p}>
                    The table above is a historical database of NFL win totals and win total odds dating back to 2003. As the season progresses, it will also fill with actual regular season wins and indicate when a team has gone over or under their win total.<br className={winStyles.content_break}/>
                    The table can be filtered by season, team, coach, and quarterback. In seasons where a team had multiple coaches or quarterbacks, the one who coached or quarterbacked the most games is shown.
                </p>
                <h2 className={winStyles.section_header}>
                    NFL Win Total Field Descriptions
                </h2>
                <p className={winStyles.content_p}>
                    In addition the fields you would expect to see like win total, regular season wins, and over/under odds, there are several computed fields that provide additional information.
                </p>
                <h3 className={winStyles.content_h3}>
                    Implied Probability
                </h3>
                <p className={winStyles.content_p}>
                    Implied probability is the likelihood a team will go over or under their project win total based on associated odds for that win total. For instance, if a team's over odds are +110, and their under odds are -134, then the market is predicting only a 45% chance that the team will go over their stated win total.  This number is important because two teams with the same win total may not actually be valued the same way by the market.
                </p>
                <h3 className={winStyles.content_h3}>
                    Hold
                </h3>
                <p className={winStyles.content_p}>
                    Hold is the percent of wagers the sports book expects to keep in profit if it takes equal action on both sides. Effectively, hold is the fee sports books charge to bettors. It's particularly important in futures markets like NFL Win Totals, where some lines can have much higher holds than you'd typically expect to find on something like weekly spreads.
                </p>
                <h3 className={winStyles.content_h3}>
                    Adj. Total
                </h3>
                <p className={winStyles.content_p}>
                    "Adj. Total" are projected win totals adjusted for the win total odds. For instance, if a team's total wins is projected to be nine games, but the over odds imply a higher probability than the under odds, Adj. Total will be higher than 9 to reflect that the market actually believes this team is better than the average "9 win" team who would otherwise have just a 50% change to go over.
                </p>
                <h3 className={winStyles.content_h3}>
                    Implied Strength
                </h3>
                <p className={winStyles.content_p}>
                    Win totals by themselves are a fairly accurate predictor of how good or bad a team will ultimately be. However, combining win totals with the league schedule in a model, creates an even more accurate predictor. The Implied Strength metrics are effectively win total based power rankings adjusted for both market hold and strength of schedule. They are represented as points against an average opponent. If a team as an implied strength of 5.5, that means this team would be expected to beat an average opponent by 5.5 points on a neutral field. By extension, a team's opponent strength is the win total implied strength of schedule.
                </p>
                
            </div>
        </div>
    )
}

export default WinTotals
